export const mockServices = [
  {
    id: 1,
    title: 'Aulas de Grupo',
    description: 'Aproveite as nossas aulas de grupo: escolha o tipo de aula e o horário que for melhor para você.',
    image: '/assets/aulas-grupo.webp',
    link: '/aulas'
  },
  {
    id: 2,
    title: 'Personal Training',
    description: 'Treinadores profissionais certificados com anos de experiência. Com a nossa equipa você alcançará os seus objetivos rapidamente.',
    image: '/assets/personal-training.webp',
    link: '/personal-training'
  },
  {
    id: 3,
    title: 'PT Online',
    description: 'Treine com acompanhamento profissional onde quer que esteja. Receba planos personalizados, orientação contínua e apoio direto para garantir resultados reais.',
    image: '/assets/pt-online.webp',
    link: '/personal-training'
  },
  {
    id: 4,
    title: 'Nutricoach',
    description: 'Planos nutricionais personalizados criados por nutricionistas especializados em desporto.',
    image: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=800&q=80',
    link: '/contactos'
  }
];

export const mockProfessores = [
  {
    id: 1,
    slug: 'manuelgonzalez',
    nome: 'Manuel Gonzalez',
    especialidade: 'Owner & Personal Trainer',
    role: 'Owner & Personal Trainer',
    foto: '/assets/manuel-gonzalez.webp',
    bio: 'Personal Trainer e fundador do Ultimate Fit. Acompanho alunos com diferentes objetivos através de planos ajustados à realidade, rotina e estilo de vida de cada pessoa.',
    bioParagraphs: [
      { text: 'Sou Personal Trainer e fundador do Ultimate Fit, treino personalizado e acompanhamento físico individualizado.' },
      { text: 'Acredito que cada pessoa precisa de um plano ajustado à sua realidade, objetivos, rotina e estilo de vida. Por isso, o meu trabalho baseia-se na proximidade, personalização, consistência e responsabilidade.', italic: true },
      { text: 'Ao longo dos anos, tenho acompanhado alunos com diferentes objetivos, desde a perda de peso e aumento da força até à melhoria da confiança, da condição física e da qualidade de vida. Tenho também experiência na preparação de atletas de desportos coletivos, ajudando-os a desenvolver capacidades físicas essenciais para melhorar o seu rendimento.' },
      { text: 'A minha missão é promover mudanças reais e duradouras através de uma ligação de confiança entre treinador e aluno. Mais do que orientar treinos, procuro acompanhar cada pessoa de forma próxima, realista e contínua, para que os resultados sejam sustentáveis.' },
      { text: 'No Ultimate Fit, acreditamos que grandes transformações são construídas passo a passo. Com autenticidade, união, personalização, humildade e uma experiência cuidada, ajudamos cada aluno a tornar-se mais forte, mais saudável e mais confiante.' }
    ],
    experiencia: '10 anos',
    certificacoes: [
      'Licenciatura e Mestrado em Gestão de Desporto',
      'Certificado em Personal Trainer, Cycling, TRX, Massagens',
      'Formação contínua na área do fitness'
    ],
    especialidades: [
      'Treino de Força',
      'Emagrecimento',
      'Reabilitação de lesões',
      'Preparação física de atletas'
    ]
  },
  {
    id: 2,
    slug: 'ruimarques',
    nome: 'Rui Marques',
    especialidade: 'Owner & Personal Trainer',
    role: 'Owner & Personal Trainer',
    foto: '/assets/rui-marques.webp',
    bio: 'Personal Trainer com formação em Educação Física e natação. Dedico-me a criar soluções práticas, ajustadas e realistas para cada aluno, focado em consistência e compromisso.',
    bioParagraphs: [
      { text: 'Sou Personal Trainer e Fundador do Ultimate Fit. Trabalho diariamente para ajudar pessoas a sentirem-se melhor no seu corpo e na sua rotina.' },
      { text: 'Ao longo dos últimos 10 anos, tenho acompanhado pessoas com objetivos muito diferentes, mas com algo em comum: a vontade de mudar. Cada percurso é único — e é por isso que o meu foco está em criar soluções práticas, ajustadas e realistas para cada aluno.' },
      { text: 'Não acredito em fórmulas iguais para todos. Acredito em consistência, compromisso e num acompanhamento próximo que faz a diferença no dia a dia.', italic: true },
      { text: 'Mais do que treinos, procuro criar um processo que seja sustentável e que se encaixe na vida de cada pessoa. Seja para perder peso, ganhar força ou simplesmente sentir-se melhor, o caminho faz-se com equilíbrio e continuidade.' },
      { text: 'No Ultimate Fit, seguimos essa mesma linha: um espaço onde o treino é personalizado, o ambiente é próximo e cada pessoa é acompanhada de forma individual. Valorizamos o trabalho consistente, a simplicidade e a evolução real ao longo do tempo.' },
      { text: 'A minha missão passa por orientar, motivar e garantir que cada aluno tem as ferramentas certas para evoluir com confiança e manter resultados duradouros.' }
    ],
    experiencia: '10 anos',
    certificacoes: [
      'Licenciatura em Desporto',
      'Mestrado em Educação Física',
      'Certificado em Personal Trainer, Pilates, TRX, Natação',
      'Formação contínua na área do fitness'
    ],
    especialidades: [
      'Perda de Peso',
      'Hipertrofia',
      'Reabilitação de lesões',
      'Pré/Pós-Parto',
      'Correção Postural'
    ]
  },
  {
    id: 3,
    slug: 'dianasantos',
    nome: 'Diana Santos',
    especialidade: 'Personal Trainer & Pilates',
    role: 'Personal Trainer & Pilates',
    foto: '/assets/diana-santos.webp',
    bio: 'Licenciada em Ciências do Desporto, Personal Trainer e professora de aulas de grupo. Foco numa evolução segura, estruturada e adaptada a cada pessoa.',
    bioParagraphs: [
      { text: 'Chamo-me Diana Santos e sou licenciada em Ciências do Desporto, Personal Trainer e professora de aulas de grupo. Ao longo de mais de 15 anos, tenho acompanhado pessoas com diferentes objetivos, sempre com foco numa evolução segura, estruturada e adaptada a cada indivíduo.' },
      { text: 'O meu trabalho baseia-se na construção de bases sólidas, respeitando o ritmo de cada pessoa e garantindo qualidade em cada fase do processo. Acredito numa abordagem metódica, onde a técnica, o controlo e a progressão são essenciais para alcançar resultados consistentes.' },
      { text: 'Resultados duradouros constroem-se com método, consistência e atenção ao detalhe.', italic: true },
      { text: 'Ao longo do meu percurso, tenho investido continuamente na minha formação, o que me permite intervir em diferentes contextos — desde aulas de grupo dinâmicas até acompanhamento individualizado.' },
      { text: 'No Ultimate Fit, sigo essa mesma linha: um trabalho próximo, cuidado e orientado para a evolução real de cada aluno. Mais do que treinar, procuro desenvolver capacidade, confiança e bem-estar de forma sustentada.' },
      { text: 'A aprendizagem contínua faz parte do meu caminho, porque acredito que evoluir como profissional é essencial para acompanhar melhor cada pessoa.' }
    ],
    experiencia: '+15 anos',
    certificacoes: [
      'Licenciatura em Ciências do Desporto',
      'Certificação em Personal Trainer',
      'Especialização em Pilates e treino funcional',
      'Formação em aulas de grupo e indoor cycling',
      'Formação em pré e pós-parto',
      'Formação contínua na área do fitness'
    ],
    especialidades: [
      'Aulas de grupo',
      'Pilates',
      'Treino funcional',
      'Perda de peso',
      'Pré e pós-parto'
    ]
  }
];

export const mockAulas = [
  {
    id: 1,
    nome: 'Ashtanga Yoga',
    descricao: 'Prática estruturada e poderosa que se concentra no domínio de poses e progressão para níveis mais avançados.',
    duracao: '60 min',
    nivel: 'Intermédio',
    imagem: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=800&q=80'
  },
  {
    id: 2,
    nome: 'Boxing',
    descricao: 'Ensinaremos os fundamentos do boxe enquanto tornamos a experiência o mais agradável possível.',
    duracao: '45 min',
    nivel: 'Todos os níveis',
    imagem: 'https://images.unsplash.com/photo-1549719386-74dfcbf7dbed?w=800&q=80'
  },
  {
    id: 3,
    nome: 'HIIT',
    descricao: 'Treino intervalado de alta intensidade para queimar calorias e melhorar a resistência cardiovascular.',
    duracao: '30 min',
    nivel: 'Avançado',
    imagem: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=800&q=80'
  },
  {
    id: 4,
    nome: 'Pilates',
    descricao: 'Fortalecimento do core, melhoria da postura e flexibilidade através de movimentos controlados.',
    duracao: '50 min',
    nivel: 'Todos os níveis',
    imagem: 'https://images.unsplash.com/photo-1518611012118-696072aa579a?w=800&q=80'
  }
];

// Aulas em destaque (homepage + página /aulas)
export const mockAulasFeatured = [
  {
    id: 'pilates',
    title: 'PILATES',
    description: 'Melhore a postura, força e controlo corporal através de movimentos precisos e controlados. Ideal para equilíbrio físico e prevenção de lesões.',
    image: '/assets/pilates.webp'
  },
  {
    id: 'yoga',
    title: 'YOGA',
    description: 'Aumente a flexibilidade, reduza o stress e fortaleça o corpo com uma prática que liga movimento, respiração e foco mental.',
    image: '/assets/yoga.webp'
  },
  {
    id: 'hiit-burn',
    title: 'HIIT BURN',
    description: 'Aula de alta intensidade com duração de 40 minutos, focada na queima de gordura, melhoria da resistência e aumento da performance física.',
    image: '/assets/hiit-burn.webp'
  }
];

export const mockPlanos = [
  {
    id: 1,
    nome: '3 Meses',
    descricao: 'Cartão de 3 meses que lhe dará acesso a todas as nossas comodidades, espaços e aulas de grupo. Não há limite de tempo, você pode vir e ir quando quiser.',
    preco: '€439',
    popular: false
  },
  {
    id: 2,
    nome: '10 Aulas',
    descricao: 'Cartão de 10 aulas dará acesso a qualquer 10 aulas de grupo. Você pode usar o cartão pelo tempo que quiser. O cartão é recarregável.',
    preco: '€169',
    popular: true
  },
  {
    id: 3,
    nome: 'Single Drop-in',
    descricao: 'Você pode comprar este passe de 1 dia para ter uma ideia se o nosso ginásio é adequado para você. Pode escolher qualquer aula de grupo.',
    preco: '€29',
    popular: false
  }
];

export const mockBeneficios = [
  { id: 1, texto: 'Personal Training', icone: 'dumbbell' },
  { id: 2, texto: 'Café & Bar', icone: 'coffee' },
  { id: 3, texto: 'Acompanhamento Nutricional', icone: 'apple' },
  { id: 4, texto: 'Vestiário & Balneário', icone: 'shirt' },
  { id: 5, texto: 'Estacionamento Gratuito', icone: 'parking-circle' },
  { id: 6, texto: 'Toalha de Treino Incluída', icone: 'check-circle' },
  { id: 7, texto: 'Cardio & Musculação', icone: 'heart-pulse' }
];

export const contactInfo = {
  telefones: ['920 627 943'],
  email: 'geral@ultimatefit.pt',
  morada: 'Rua Monsenhor Miguel de Oliveira 1366 - 1º andar, 3880-796 Ovar, PT',
  horario: {
    semana: 'Seg a Sexta: 7:00 — 21:00',
    sabado: 'Sab: 8:00 — 13:00'
  },
  socials: {
    instagram: 'https://www.instagram.com/ultimatefit.pt',
    facebook: 'https://www.facebook.com/ultimatefit.ovar'
  },
  spotify: 'https://open.spotify.com/playlist/0kbtd39P0RhCUlUdlG4L8j'
};